(() => {
  let activeScroll;

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a.product__rating[href="#judgeme_product_reviews"]');
    const target = document.getElementById('judgeme_product_reviews');
    if (!link || !target || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    event.stopPropagation();
    activeScroll?.abort();
    const controller = new AbortController();
    activeScroll = controller;
    const { signal } = controller;
    const cancel = () => controller.abort();
    ['wheel', 'touchstart', 'pointerdown'].forEach((name) => {
      window.addEventListener(name, cancel, { passive: true, signal });
    });
    window.addEventListener('keydown', (keyEvent) => {
      if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', 'Escape', ' '].includes(keyEvent.key)) cancel();
    }, { signal });

    try {
      const sections = Array.from(document.querySelectorAll('main product-recommendations, main recently-viewed'))
        .filter((section) => section.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING);
      await Promise.all(sections.map(async (section) => {
        await customElements.whenDefined(section.localName);
        await section.init();
      }));
      await document.fonts.ready;
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (signal.aborted || !target.isConnected) return;

      const destination = () => {
        const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 16;
        return Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
      };
      if (window.location.hash !== link.hash) window.history.pushState(window.history.state, '', link.hash);
      const start = window.scrollY;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      await new Promise((resolve) => {
        let started;
        let frame;
        const stop = () => {
          cancelAnimationFrame(frame);
          resolve();
        };
        signal.addEventListener('abort', stop, { once: true });
        const step = (now) => {
          if (signal.aborted || !target.isConnected) return stop();
          started ??= now;
          const progress = reducedMotion ? 1 : Math.min(1, (now - started) / 520);
          const eased = 1 - Math.pow(1 - progress, 3);
          window.scrollTo({ top: start + (destination() - start) * eased, behavior: 'instant' });
          if (progress < 1) frame = requestAnimationFrame(step);
          else {
            signal.removeEventListener('abort', stop);
            resolve();
          }
        };
        frame = requestAnimationFrame(step);
      });
    }
    finally {
      controller.abort();
      if (activeScroll === controller) activeScroll = null;
    }
  }, true);
})();
